export default __webpack_public_path__ + "static/media/CHSE.edff6e8e.jpeg";